import { StyleSheet } from '@react-pdf/renderer';

export const checklistStyles = StyleSheet.create({
  // Grid: 3 columns per row
  gridRow: {
    flexDirection: 'row',
    paddingHorizontal: 8,
    paddingVertical: 6,
    borderBottom: '1 solid #D6DBE7',
  },
  gridItem: {
    flex: 1,
    flexDirection: 'column',
    gap: 2,
    overflow: 'hidden',
  },
  gridLabel: {
    fontSize: 7.5,
    color: '#000000',
    fontWeight: 'normal',
  },
  gridValue: {
    fontSize: 9,
    color: '#000000',
    fontWeight: 'bold',
  },

  // Full-width question item
  questionItem: {
    paddingHorizontal: 8,
    paddingVertical: 6,
    borderBottom: '1 solid #D6DBE7',
  },
  questionText: {
    fontSize: 7.5,
    color: '#000000',
    fontWeight: 'normal',
    marginBottom: 2,
  },
  answerContainer: {
    paddingLeft: 0,
  },
  answerText: {
    fontSize: 9,
    color: '#000000',
    fontWeight: 'bold',
  },
  photoPlaceholder: {
    fontSize: 8,
    color: '#000000',
    fontStyle: 'italic',
  },
  fileItem: {
    flexDirection: 'row',
    marginBottom: 2,
  },
  fileBullet: {
    fontSize: 8,
    color: '#000000',
    marginRight: 4,
  },
  fileName: {
    fontSize: 8,
    color: '#000000',
  },

  // Sub-section header (dark accent bar)
  subSectionHeader: {
    flexDirection: 'row',
    alignItems: 'center',
    backgroundColor: '#F5F6F9',
    gap: 8,
    paddingRight: 8,
  },
  subSectionAccent: {
    width: 3,
    height: 28,
    backgroundColor: '#101010',
  },
  subSectionTitle: {
    color: '#000000',
    fontSize: 9,
    fontWeight: 'bold',
  },
});
